import { useState } from "react";
import CustomDialog from "../../../components/Dialog/DiaCompMedium";
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Grid from '@mui/material/Grid';
import AddPackages from "./AddPackages";

export default function DiaAddPackages({infotitle, infotext}) {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};
  
    return (
      <>
    
  
        <Tooltip title="Add Packages" placement="right">
            <IconButton onClick={handleOpen} aria-label="Reschedule" sx={{ '&:hover': {transform: 'scale(1.2)'}, }} >
                <ShoppingCartIcon size="large" sx={{color: 'warning.main', '&:hover': { transform: 'scale(1.3)'}, }}/>
            </IconButton>   
        </Tooltip>
   
    <CustomDialog open={open} onClose={handleClose}

          title="Optionally add additional bloodtest packages"
         
          content = {
          
           <Grid container>
              <Grid size={12} sx={{display:'flex', justifyContent:'center', alignItems:'center'}}>  
               
               <AddPackages />
              
              </Grid>
            </Grid>
            }

        />
        
</>
)}